import { XState } from '@frontend/duck-tape';
import type { WizardEvent } from '@frontend/forms';

export const joinWaitlistFlowMachine = XState.setup({
  guards: {
    validateField: (_, params: { field: string }) => {
      return !!params.field;
    },
  },
  types: {
    events: {} as WizardEvent,
  },
}).createMachine({
  id: 'waitlistWizard',
  initial: 'email',
  states: {
    confirmation: {
      on: {
        next: {
          target: 'done',
        },
      },
    },
    done: {
      type: 'final',
    },
    email: {
      on: {
        next: {
          guard: { params: { field: 'email' }, type: 'validateField' },
          target: 'firstName',
        },
      },
    },
    firstName: {
      on: {
        back: {
          target: 'email',
        },
        next: {
          guard: { params: { field: 'firstName' }, type: 'validateField' },
          target: 'lastName',
        },
      },
    },
    hdyhau: {
      on: {
        back: {
          target: 'promoCode',
        },
        navigateToEmail: {
          target: 'email',
        },
        navigateToPhoneNumber: {
          target: 'phoneNumber',
        },
        next: {
          target: 'confirmation',
        },
      },
    },
    lastName: {
      on: {
        back: {
          target: 'firstName',
        },
        next: {
          guard: { params: { field: 'lastName' }, type: 'validateField' },
          target: 'phoneNumber',
        },
      },
    },
    phoneNumber: {
      on: {
        back: {
          target: 'lastName',
        },
        next: {
          guard: { params: { field: 'phoneNumber' }, type: 'validateField' },
          target: 'promoCode',
        },
      },
    },
    promoCode: {
      on: {
        back: {
          target: 'phoneNumber',
        },
        next: {
          target: 'hdyhau',
        },
      },
    },
  },
});
